<template>
  <div v-show="isActive">
    <slot />
  </div>
</template>

<script>
export default {
  name: "VariantContent",
};
</script>

<script setup>
import {computed} from "vue";
import {useStore} from "vuex";

/**
 * Shows its slot only when the given variant is the one currently selected
 * in the shared product store. Used to make PDP accordion content
 * (nutrition / ingredients / recommended use) react to variant switches
 * without a page reload. Falls back to `isDefault` before the store has a
 * selected variant (initial mount).
 */
const props = defineProps({
  variantId: {
    type: [String, Number],
    required: true,
  },
  isDefault: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();

const isActive = computed(() => {
  const selected = store.state.product.selectedVariant;
  if (!selected) return props.isDefault;
  return String(selected.id) === String(props.variantId);
});
</script>
